import { FAQPageJsonLd } from 'next-seo';
import Head from 'next/head';
import React from 'react';
import { article_faq } from '../../Constants/ArticlesFaqs';
import { images } from '../../Constants/ImageUrls';
import { BrandName } from '../../Constants/ProductPage';

export default function ArticleHead(props) {
  const { content, language, articleId } = props;
  const defaultImg = images.defaultImage;
  const faqsData = article_faq[articleId];

  return (
    <>
      <Head>
        <link rel="preload" href={defaultImg} as="image" fetchPriority="high" />
        {/* {articleImage && (
                <link
                    rel="preload"
                    as="image"
                    fetchPriority="high"
                    href={`${articleImage}?tr=w-550,q-60`}
                />
            )} */}
        {/* <script
                    async
                    src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                ></script> */}
        <script
          async
          src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        ></script>

        <script
          key="organizationLD"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `{"@context": "https://schema.org",
                        "@graph": [{
                            "@type": "Organization",
                            "name": "${BrandName}",
                            "alternateName": "Mylo",
                            "url": "https://mylofamily.com",
                            "logo": "${images.headingLogo}"
                        }, {
                          "@type": "WebSite",
                          "@id": "https://mylofamily.com/#website",
                          "url": "https://mylofamily.com/",
                          "name": "${BrandName}",
                          "publisher": {
                            "@id": "https://mylofamily.com/#organization"
                          }
                        }, {
                          "@type": "WebPage",
                          "@id": "https://mylofamily.com${
                            content?.web_url
                          }#webpage",
                          "url": "https://mylofamily.com${content?.web_url}",
                          "inLanguage": "${language}",
                          "name": "${content.title.trim()}",
                          "isPartOf": {
                            "@id": "https://mylofamily.com/#website"
                          },
                          "about": {
                            "@id": "https://mylofamily.com/#organization"
                          },
                          "datePublished": "${
                            content?.created_at?.split(' ')?.[0]
                          }",
                            "image": {
                            "@type": "ImageObject",
                            "@id": "#primaryimage",
                            "url": "${images.headingLogo}",
                            "width": 800,
                            "height": 800,
                            "caption": ""
                          },
                          "primaryImageOfPage": {
                            "@id": "#primaryimage"
                          }
                        }]}`,
          }}
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `{"@context": "https://schema.org",
                    "@type": "Article",
                    "headline": "${content.title.trim()}",
                    "image": "${content?.webpImages?.[0]}",  
                    "author": {
                      "@type": "Organization",
                      "name": "${BrandName}"
                    },  
                    "publisher": {
                      "@type": "Organization",
                      "name": "${BrandName}",
                      "logo": {
                        "@type": "ImageObject",
                        "url": "${images.headingLogo}"
                      }
                    },
                    "datePublished": "${
                      content?.created_at?.split(' ')?.[0]
                    }"}`,
          }}
        />
      </Head>
      {faqsData?.length > 0 && <FAQPageJsonLd mainEntity={faqsData} />}
    </>
  );
}
